import React, { Component } from 'react'

class NavBar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            menuOpen: false,
            scrolled: false
        }

        this.openNav = this.openNav.bind(this)
        this.closeNav = this.closeNav.bind(this)
        this.handleScroll = this.handleScroll.bind(this)
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    handleScroll() {
        const scrolled = window.scrollY > 50
        if (scrolled !== this.state.scrolled) {
            this.setState({ scrolled })
        }
    }

    openNav() {
        this.setState({ menuOpen: true })
    }

    closeNav() {
        this.setState({ menuOpen: false })
    }

    render() {
        const navStyle = this.state.menuOpen
            ? { height: window.matchMedia("(min-width: 1024px)").matches ? "60%" : "100%" }
            : { height: "0%" }

        return (
            <header>
                <div className={"nav_bar" + (this.state.scrolled ? " scrolled" : "")}>
                    <a href="/"><img src={process.env.PUBLIC_URL + "/image/doday_logo_copy.png"} className="logo" alt="DoDay Logo"/></a>
                    <nav className="desktop_nav">
                        <a href="/">主頁</a>
                        <a href="/about">關於我們</a>
                        <a href="/menu">菜單</a>
                        <a href="/contact">聯絡我們</a>
                        <a href="https://order.doday.com.tw" className="nav_cta" target="_blank" rel="noopener noreferrer">線上點餐</a>
                    </nav>
                    <a href="#" className="icon" onClick={(e) => { e.preventDefault(); this.openNav(); }}>&#9776;</a>
                </div>
                <div
                    aria-label="mobile menu"
                    style={navStyle}
                    className={"mobile_nav" + (this.state.menuOpen ? " open" : "")}
                >
                    <a href="#" className="closebtn" onClick={(e) => { e.preventDefault(); this.closeNav(); }}>&times;</a>
                    <div className="mobile_nav_list">
                        <a href="/" onClick={this.closeNav}>主頁</a>
                        <a href="/about" onClick={this.closeNav}>關於我們</a>
                        <a href="/menu" onClick={this.closeNav}>菜單</a>
                        <a href="/contact" onClick={this.closeNav}>聯絡我們</a>
                        <a href="/order" onClick={this.closeNav}>線上點餐</a>
                    </div>
                </div>
            </header>
        );
    }
}

export default NavBar;
